import React from 'react';

import { Steps, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import {
  ApprovalStepSchema,
  ArtifactItemSchema,
  OrderItemSchema,
  OrderTotal,
  RetrieveOrderSchema,
} from '@app/models/orders';

import { Paper } from '@components/Paper';

import { ItemsTable } from '../ItemsTable';

interface IProps {
  artifact: ArtifactItemSchema;
  orderData?: RetrieveOrderSchema;
}

interface IArtifactData {
  steps?: ApprovalStepSchema[];
  items?: OrderItemSchema[];
  total?: OrderTotal;
  total_items?: number;
  show_multiplicity_indicator?: boolean;
}

export const OrderArtifact: React.FC<IProps> = ({ artifact, orderData }) => {
  const orderT = useTranslation(NSKeys.order);
  const artifacts = orderData?.artifacts;
  const artifactData = artifacts?.[artifact.data.uid] as IArtifactData | null | undefined;
  const artifactDataView = orderData?.$artifacts?.[artifact.data.uid]?.view;

  if (!artifactDataView) {
    return null;
  }

  if (artifact.data.type === 'approval_route' && artifacts) {
    const steps = artifactData?.steps;

    if (steps?.length) {
      return (
        <Paper>
          <Typography.Title level={3}>{orderT.t('blockSteps.title')}</Typography.Title>
          <Steps
            labelPlacement="vertical"
            size="small"
            style={{ margin: '20px 0' }}
            items={steps.map((step, i) => ({
              title: orderT.t('blockSteps.steps', { step: i + 1 }),
              status: step?.is_current ? 'process' : step?.is_passed ? 'finish' : 'wait',
              description: step.user_group.name,
            }))}
          />
        </Paper>
      );
    }
  }

  if (artifact.data.type === 'order_items' && artifacts) {
    const items = artifactData?.items;
    const total = artifactData?.total;
    const total_items = artifactData?.total_items;
    const show_multiplicity_indicator = artifactData?.show_multiplicity_indicator;

    return (
      <Paper>
        <ItemsTable
          data={items || []}
          total_items={total_items}
          total={total}
          show_multiplicity_indicator={show_multiplicity_indicator}
        />
      </Paper>
    );
  }

  return null;
};
